import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import Button from '../button';
import SelectionList from '../selection-list';
import {Modal} from 'react-bootstrap';

export default function OrganizationSelectionModal(props) {
  const {organizations, currentOrganization, onChange, show, onClose, ...rest} = props;
  const [selected, setSelected] = React.useState(
    currentOrganization && organizations.find(o => o.id === currentOrganization),
  );
  const onSelectionChanged = React.useCallback(selectedOrganization => setSelected(selectedOrganization));

  const onSubmit = React.useCallback(() => {
    !selected || selected.id === currentOrganization ? onClose() : onChange(selected);
  });

  return (
    <Modal dialogClassName="organization-selection-modal" show={show} onHide={onClose} size="lg" centered {...rest}>
      <Modal.Header closeButton>
        <Modal.Title>
          <I18n t="select-organization-view.title" />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SelectionList
          items={organizations}
          initialSelectedValue={currentOrganization}
          onChange={onSelectionChanged}
          valueField="id"
          nameField="name"
          descriptionField={null}
          searchPlaceholder={I18n.t('select-organization-view.search-placeholder')}
          label={I18n.t('select-organization-view.available-organizations')}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-dark" onClick={onClose}>
          <I18n t="action.close" />
        </Button>
        <Button variant="primary" type="submit" disabled={!selected} onClick={onSubmit}>
          <I18n t="select-organization-view.change" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

OrganizationSelectionModal.propTypes = {
  /** An array of organizations that can be selected. */
  organizations: PropTypes.array.isRequired,
  /** The currently selected organization. */
  currentOrganization: PropTypes.any.isRequired,
  /** A callback to execute when an organization is selected. */
  onChange: PropTypes.func.isRequired,
  /** Whether or not the modal should be visible. */
  show: PropTypes.bool.isRequired,
  /** A callback to execute when the modal is closed. */
  onClose: PropTypes.func.isRequired,
};
